import Buildings from '@/images/Buildings.svg';
import User from '@/images/User.svg';
import { Step } from '../components/steps/Step';
import { OnboardingClass, OnboardingFlows } from './common';

export const purposeStep: Step = {
    id: OnboardingFlows.Class,
    title: 'What will you use D-ID for?',
    multiSelect: false,
    randomize: true,
    options: [
        {
            id: OnboardingClass.Work as string,
            label: 'Work',
            icon: Buildings,
        },
        {
            id: OnboardingClass.Personal as string,
            label: 'Personal',
            icon: User,
        },
    ],
};
